function slidersInit() {
  $('.brand_logos--slider-for').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay:true,
    autoplaySpeed: 1000,
    focusOnSelect: true,
    asNavFor: '.brand_logos--slider-nav',
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          dots: false,
          arrows: true,
          variableWidth: true,
          adaptiveHeight: true,
        },
      },
    ],
  })

  $('.brand_logos--slider-nav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.brand_logos--slider-for',
    dots: false,
    arrows: false,
    fade: true,
    infinite: true,
    autoplay:true,
    autoplaySpeed: 1000,
    centerMode: false,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          centerMode: true,
          dots: false,
          arrows: false,
        },
      },
    ],
  })
}
slidersInit()

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    slidersInit()
  })
}


// $(function () {
//     function slidersInit11() {
//       $('.ann-parent').slick({
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: false,
//         dots: false,
//         infinite: true,
//         autoplay: true,
//         loop: true,
//         autoplaySpeed: 400,
//       });
//     }
//     slidersInit11();

//     if (Shopify.designMode) {
//       document.addEventListener('shopify:section:load', () => {
//         slidersInit11();
//       });
//     }
//   });